import { t } from "ttag";

import { IS_CUBE_UI } from "metabase/cube";
import { isWithinIframe } from "metabase/lib/dom";

import ViewSection, { ViewHeading } from "./ViewSection";

export default function NewQuestionHeader(props) {
  const isCubeVersion = IS_CUBE_UI && isWithinIframe();
  return (
    <ViewSection {...props}>
      <ViewHeading>
        {isCubeVersion ? t`New Question` : t`Pick your starting data`}
      </ViewHeading>
    </ViewSection>
  );
}
